export default {
      id: "restore-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#restore",
      toString: function () {
        return this.url;
      }
    }